module.exports = __webpack_public_path__ + "static/media/horoscope-icon-white-3.595066b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-white-3.png
// module id = 193
// module chunks = 0